/**
 * Set your nunjucks variables here
 */

const ENVIROMENT = process.env.NODE_ENV || process.env.ENVIROMENT || 'staging'

/** Default */
const config = {
  title: 'Substrakt TNEW v7 Template',
  publicPath: 'https://scottish-ballet-assets.s3-eu-west-1.amazonaws.com/tnew-template/qa',
  tnewUrl: 'https://sbal-tnew-test.tnhs.cloud',
  siteUrl: 'https://scottishballet.co.uk',
  gtm: 'WN4L45H'
}

if (ENVIROMENT === 'production') {
  config.publicPath = 'https://scottish-ballet-assets.s3-eu-west-1.amazonaws.com/tnew-template/live'
  config.tnewUrl = 'https://basket.scottishballet.co.uk'
}

// For direct debit processing
if (ENVIROMENT === 'production') {
    config.directDebitCampaign = '1264.928'
    config.directDebitURL = 'https://rsm2.rsmsecure.com/directdebit/dd.php'
  }
else {
    config.directDebitCampaign = '333.220'
    config.directDebitURL = 'https://rsm3.rsmsecure.com/demo/directdebit/dd.php'
}

module.exports = config
